"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../Button/helpers");
var styles_1 = require("../Button/styles");
var helpers_2 = require("./helpers");
function SplitButton(_a) {
    var _b = _a.as, Component = _b === void 0 ? "button" : _b, side = _a.side, baseStyle = _a.style, props = __rest(_a, ["as", "side", "style"]);
    var style = (0, helpers_2.getSplitButtonStyle)({ side: side });
    var variantStyle = (0, helpers_1.getButtonVariantStyles)({
        variant: props.variant,
        format: props.format,
        size: props.size,
    });
    return (react_1.default.createElement(styles_1.ButtonContainer, __assign({ as: Component, variantStyle: variantStyle, style: __assign(__assign({}, style), baseStyle) }, props), props.children));
}
exports.default = SplitButton;
//# sourceMappingURL=index.js.map